// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"80b260aa","404":"ba11dc07","787":"9f694821"}[chunkId] + ".chunk.js";
};